export default function ManagePlacePayAccount() {
  return null;
}
